<template>
  <b-container fluid="lg">
    <b-row>
      <b-col cols="4">Nombre*</b-col>
      <b-col>Compte Pais*</b-col>
      <b-col>Compte Banc*</b-col>
      <b-col>Compte Oficina*</b-col>
      <b-col>DC*</b-col>
      <b-col cols="2">Compte Codi*</b-col>
      <b-col cols="2"></b-col>
    </b-row>
    <b-form-row>
      <b-col cols="4">
        <b-input
          required
          autofocus
          maxlength="50"
          type="text"
          v-model="newBanc.Nombre"
          v-on:keyup.13="addBanc"
          v-on:keyup.esc="cancelForm"
        ></b-input>
      </b-col>
      <b-col>
        <b-input
          required
          maxlength="4"
          type="text"
          v-model="newBanc.Pais"
          v-on:keyup.13="addBanc"
          v-on:keyup.esc="cancelForm"
        ></b-input>
      </b-col>
      <b-col>
        <b-input
          required
          maxlength="4"
          type="text"
          v-model="newBanc.EntidadFinanciera"
          v-on:keyup.13="addBanc"
          v-on:keyup.esc="cancelForm"
        ></b-input>
      </b-col>
      <b-col>
        <b-input
          required
          maxlength="4"
          type="text"
          v-model="newBanc.Oficina"
          v-on:keyup.13="addBanc"
          v-on:keyup.esc="cancelForm"
        ></b-input>
      </b-col>
      <b-col>
        <b-input
          required
          maxlength="2"
          type="text"
          v-model="newBanc.DC"
          v-on:keyup.13="addBanc"
          v-on:keyup.esc="cancelForm"
        ></b-input>
      </b-col>
      <b-col cols="2">
        <b-input
          required
          maxlength="10"
          type="text"
          v-model="newBanc.NumeroCuenta"
          v-on:keyup.13="addBanc"
          v-on:keyup.esc="cancelForm"
        ></b-input>
      </b-col>
      <b-col cols="2">
        <b-button
          v-on:click="addBanc"
          size="sm"
          variant="outline-success"
          class="mb-2"
        >
          <b-icon icon="file-plus" aria-hidden="true"></b-icon>
          <span class="sr-only">Help</span>
        </b-button>
      </b-col>
    </b-form-row>
    <table class="table table-striped">
      <thead>
        <tr v-if="!edit">
          <th cols="4">Nom</th>
          <th>Compte Bancari</th>
          <th style="width: 10%">Actiu</th>
          <th style="width: 10%">Accions</th>
        </tr>
        <tr v-else>
          <th cols="4">Nom</th>
          <th>Compte Pais</th>
          <th>Banc</th>
          <th>Oficina</th>
          <th>DC</th>
          <th cols="2">Código</th>
          <th style="width: 10%">Actiu</th>
          <th style="width: 10%">Accions</th>
        </tr>
      </thead>
      <tbody>
        <BancComponent
          v-for="(item, i) in this.bancsData"
          :key="item.identifier"
          @deleteBanc="(data) => deleteBanc(i, data)"
          @updateBanc="(data) => updateBanc(i, data)"
          @editarBanc="(data) => editarBanc(i, data)"
          @cancelBanc="(data) => cancelBanc(i, data)"
          v-bind:banc="item"
        />
      </tbody>
    </table>
  </b-container>
</template>

<script>
import BancComponent from '@/components/Banc/BancComponent.vue'
import DataAccess from '@/Services/DataAccess.js'

export default {
  components: {
    BancComponent
  },
  data () {
    return {
      edit: false,
      bancsData: [],
      newBanc: {
        identifier: null,
        Nombre: '',
        Pais: '',
        EntidadFinanciera: '',
        Oficina: '',
        DC: '',
        NumeroCuenta: ''
      }
    }
  },
  created () {
    (async () => {
      await DataAccess.getData('/api/bancs')
        .then((response) => {
          this.bancsData = response.data
          this.loading = false
        })
        .catch((error) => {
          this.makeToast(
            'b-toaster-top-full',
            'danger',
            'Error en la càrrega incial.',
            error.response.data
          )
          console.log('ERROR CARREGA - BANC:', error.response.data)
        })
    })()
  },
  methods: {
    makeToast (toaster, variant, title, message, append = false) {
      this.$bvToast.toast(message, {
        toaster: toaster,
        title: title,
        variant: variant,
        solid: true,
        append: append
      })
    },
    cancelForm () {
      this.newBanc.identifier = null
      this.newBanc.Nombre = ''
      this.newBanc.Pais = ''
      this.newBanc.EntidadFinanciera = ''
      this.newBanc.Oficina = ''
      this.newBanc.DC = ''
      this.newBanc.NumeroCuenta = ''
    },
    addBanc () {
      if (
        !this.newBanc.Nombre ||
          !this.newBanc.Pais ||
          !this.newBanc.EntidadFinanciera ||
          !this.newBanc.Oficina ||
          !this.newBanc.DC ||
          !this.newBanc.NumeroCuenta
      ) {
        this.makeToast(
          'b-toaster-top-right',
          'danger',
          'Nuevo Registro',
          'Rellene los campos del Banco.'
        )
      } else {
        (async () => {
          await DataAccess.postData('/api/bancs', JSON.stringify(this.newBanc))
            .then((response) => {
              this.bancsData.push(response.data)
              this.makeToast(
                'b-toaster-top-right',
                'success',
                'Nuevo Registro',
                'Registre creat amb èxit".'
              )
              this.cancelForm()
              //   this.newBanc.identifier = null
              //   this.newSerie.descripcion = null
            })
            .catch((error) => {
              this.makeToast(
                'b-toaster-top-right',
                'danger',
                'Alta de Registre',
                error.response.data
              )
              console.log('ERROR ALTA - SERIE: ', error.response.data)
            })
        })()
      }
    },
    deleteBanc (indice, item) {
      this.$bvModal
        .msgBoxConfirm(
          'Desitja esborrar el compte Bancari: ' + item.nombre + ' ?',
          {
            title: 'Borrat de Registre - Siusplau confirmi',
            size: 'lm',
            buttonSize: 'lm',
            okVariant: 'success',
            okTitle: 'SI',
            cancelTitle: 'NO',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
          }
        )
        .then((value) => {
          if (value) {
            (async () => {
              await DataAccess.deleteData('/api/bancs', item.identifier)
                .then((response) => {
                  this.bancsData.splice(indice, 1)
                  this.makeToast(
                    'b-toaster-top-right',
                    'success',
                    'Esborrat de Registre',
                    'Registre esborrat amb èxit.'
                  )
                })
                .catch((error) => {
                  this.makeToast(
                    'b-toaster-top-right',
                    'danger',
                    'Esborrat de Registre',
                    error.response.data
                  )
                  console.log('ERROR ESBORRAT - BANC: ', error.response.data)
                })
            })()
          }
        })
    },
    editarBanc (indice, item) {
      this.edit = true
    },
    cancelBanc (indice, item) {
      this.edit = false
    },
    updateBanc (indice, item) {
      if (
        !item.nombre ||
          !item.pais ||
          !item.entidadFinanciera ||
          !item.oficina ||
          !item.dc ||
          !item.numeroCuenta
      ) {
        this.makeToast(
          'b-toaster-top-right',
          'danger',
          'Nuevo Registro',
          'Rellene los campos del Banco.'
        )
      } else {
        (async () => {
          await DataAccess.putData(
            '/api/bancs',
            item.identifier,
            JSON.stringify(item)
          )
            .then((response) => {
              // RETORNA EL FORMULARI A VIEW MODEL
              this.edit = false
              this.makeToast(
                'b-toaster-top-right',
                'success',
                'Actualització de Registre',
                'Registre actualitzat amb èxit.'
              )
            })
            .catch((error) => {
              this.makeToast(
                'b-toaster-top-right',
                'danger',
                'Actualització de Registre',
                error.response.data
              )
              console.log('ERROR ACTUALITZACIO - SERIE: ', error.response.data)
            })
        })()
      }
    }
  }
}
</script>
